import React, { useEffect, useCallback, useState } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import EditIcon from '@material-ui/icons/Edit';
import WifiTetheringIcon from '@material-ui/icons/WifiTethering';
import { CircularProgress } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { isUndefined, isEmpty, isNull } from 'lodash';

import './index.scss';
import EditLiveContent from '../../components/EditLiveContent';
import { uploadContentService } from '../../services';

import { useHistory } from 'react-router-dom';

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "#252525",
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
        color: theme.palette.common.white,
    },
    button: {
    }
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: "#424242",
        },
        '&:nth-of-type(even)': {
            backgroundColor: "#252525",
        },
    },
}))(TableRow);

function createData(SPILLELISTER, BUTTON) {
    return { SPILLELISTER, BUTTON };
}

const useStyles = makeStyles({
    table: {
        maxWidth: 2000,

    },
    button: {
        marginTop: 10,
        height: 40,
        width: 200,
        float: 'right',
        fontSize: 15,
        fontWeight: 'bold',
        color: '#ffffff',
        backgroundColor: '#6C6C6C'
    }
});

export default function MusicTable() {
    const classes = useStyles();
    const history = useHistory();

    const [dynamicPlaylists, setDynamicPlaylists] = useState([]);
    const { user } = useSelector(state => state.userAuthentication);

    const handleSendToDevice = async (event) => {
        if (event.currentTarget.dataset.value === "playlist") {
            await uploadContentService.uploadSendPlaylistToDevice(user, parseInt(event.currentTarget.dataset.id))
        }
    }

    const getDynamicPlaylists = useCallback(async () => {
        if (!isUndefined(user)) {
            const res = await uploadContentService.getMusicPlaylist(user);
            setDynamicPlaylists(res);
        }
    }, [user]);

    useEffect(() => {
        getDynamicPlaylists();
    }, [getDynamicPlaylists]);

    return (
        <div>
            <span className="span-design">
                <div className="icon-design"><WifiTetheringIcon /> MUSIC </div>
                <h3 className="text-design">  CONTENT </h3>
            </span>
            <TableContainer component={Paper} className={classes.table}>
                <Table className={classes.table} aria-label="customized table">
                    <TableHead>
                        <TableRow>
                            <StyledTableCell align="left">MUSICMIND PLAYLIST</StyledTableCell>
                            <StyledTableCell align="right">&nbsp;</StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {!isUndefined(dynamicPlaylists) ? (
                            [...dynamicPlaylists].map(item => (
                                <StyledTableRow key={item.name} >
                                    <StyledTableCell align="left">{item.name}</StyledTableCell>
                                    <StyledTableCell align="left"> <Button
                                        onClick={handleSendToDevice}
                                        variant="contained"
                                        data-value="playlist"
                                        data-id={item.id}
                                        className={classes.button}
                                    >
                                        SEND TO DEVICE
                                    </Button></StyledTableCell>

                                </StyledTableRow>
                            ))
                        ) : (
                            <div className="loader">
                                <CircularProgress />
                            </div>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    );
}